import React, { useEffect, useMemo, useState } from 'react';
import AddressSavedModal from './AddressSavedModal';
import { TStep3Branch } from '../../../types';
import Dropdown from '../../../common/dropdown/Dropdown';
import Button2 from '../../global/Button2';
import { setInLocalStorageLtd } from '../../../utils/setRegInfoInLocalStorage';

interface IProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  description: string;
  branchInfo: TStep3Branch;
  states: any[];
  nearestSterlingStates: any[];
  lgaLoading: boolean;
  branchLoading: boolean;
  setShowSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  showSuccessModal: boolean;
  branchIndex: number;
  branches: TStep3Branch[];
  setBranches: React.Dispatch<React.SetStateAction<TStep3Branch[]>>;
  updateBranchesInTable: React.Dispatch<React.SetStateAction<TStep3Branch[]>>;
}
const EditAddressModal = ({
  showModal,
  setShowModal,
  branchInfo,
  description,
  states,
  lgaLoading,
  nearestSterlingStates,
  branchLoading,
  setShowSuccessModal,
  showSuccessModal,
  branchIndex,
  branches,
  setBranches,
  updateBranchesInTable,
}: IProps) => {
  const [updatedBranchInfo, setUpdatedBranchInfo] = useState(branchInfo);
  const [disabled, setDisabled] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const displayErrorMsg = (errorText: string, variable: string) => {
    if (submitting && !variable) {
      return <div className='text-[red] text-[11px]'>{errorText}</div>;
    }
  };

  const validateInputsResult = useMemo(() => {
    const isStreetNo = branchInfo?.streetNumber;
    const isStreetName = branchInfo?.streetName;
    const isState = branchInfo?.selectedState;
    const isLga = branchInfo?.selectedLga;
    const isNearestState = branchInfo?.nearestSterlingState?.label;
    const isNearestBranch = branchInfo?.nearestSterlingBranch;
    const isHasBranch = branches?.length === 0 ? branchInfo?.hasBranch : true;

    return (
      isState &&
      isStreetName &&
      isStreetNo &&
      isLga &&
      isNearestState &&
      isNearestBranch &&
      isHasBranch
    );
  }, [branchInfo]);

  useEffect(() => {
    setUpdatedBranchInfo(branches[branchIndex]);
  }, [branchIndex]);

  useEffect(() => {
    if (validateInputsResult) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [validateInputsResult]);
  return (
    <>
      {showModal ? (
        <>
          <div className='fixed inset-0 z-[1000000] overflow-y-auto rounded-[4px]'>
            <div
              className='fixed inset-0 w-full h-full bg-black opacity-40'
              onClick={() => setShowModal(false)}
            ></div>
            <div className='flex items-center h-full py-4'>
              <div className='relative p-[1.6em] max-h-[85%] overflow-y-auto mx-auto bg-white rounded-md shadow-lg'>
                <div className='sm:mt-[1.5em] w-[300px] md:w-[500px] sm:flex flex-col justify-center'>
                  <div className=' text-center sm:text-left'>
                    <div className='text-[16px] mb-6 font-[500]'>{description}</div>
                  </div>

                  <div className='flex justify-center flex-col md:w-full  mx-auto'>
                    <div className='w-full'>
                      <div className='sl:flex justify-between'>
                        <div className='w-full sl:w-[48%] text-xs mb-[37px] '>
                          <h4 className='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '>
                            Street number and name
                          </h4>
                          <div className='flex flex-row gap-3 '>
                            <div className='w-[70px]'>
                              <div className=''>
                                {/* <label className='flex flex-col relative text-[#212121] '>Business name 1</label> */}
                                <input
                                  className='w-full h-[45px] text-center text-[#768396] font-normal text-xs px-2 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                                  value={updatedBranchInfo?.streetNumber ?? ''}
                                  placeholder={'#'}
                                  onChange={(e) => {
                                    setUpdatedBranchInfo((prev) => ({
                                      ...prev,
                                      streetNumber: e.target.value.replace(/[^a-z] /gi, ''),
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                            <div className='w-full'>
                              <div className=''>
                                {/* <label className='flex flex-col relative text-[#212121] '>Business name 1</label> */}
                                <input
                                  className='w-full h-[45px] text-[#768396] font-normal text-xs px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                                  value={updatedBranchInfo?.streetName ?? ''}
                                  placeholder={'Type street name'}
                                  onChange={(e) => {
                                    setUpdatedBranchInfo((prev) => ({
                                      ...prev,
                                      streetName: e.target.value.replace(/[0-9]/g, ''),
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          {displayErrorMsg(
                            'Street number cannot be empty',
                            updatedBranchInfo?.streetNumber,
                          )}
                          {displayErrorMsg(
                            'Street name cannot be empty',
                            updatedBranchInfo?.streetName,
                          )}
                        </div>
                        <div className='w-full sl:w-[48%] text-xs mb-[37px] '>
                          <div className='w-full text-xs'>
                            <Dropdown
                              className='border rounded-[2px] !h-[45px] '
                              label='Located State'
                              placeholder={''}
                              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                              options={
                                states &&
                                states.map((state: any) => {
                                  return {
                                    label: state.name,
                                    value: state.name,
                                  };
                                })
                              }
                              width='100%'
                              value={updatedBranchInfo?.selectedState}
                              setSelectedOption={(e: { label: string; value: string }) => {
                                setUpdatedBranchInfo((prev) => ({
                                  ...prev,
                                  selectedState: e.label,
                                }));
                              }}
                              isLoading={lgaLoading}
                            />
                          </div>
                          {displayErrorMsg(
                            'State cannot be empty',
                            updatedBranchInfo?.selectedState,
                          )}
                        </div>
                      </div>
                      <div className='sl:flex justify-between'>
                        <div className='w-full sl:w-[48%] text-xs mb-[37px] '>
                          <Dropdown
                            className='border rounded-[2px] !h-[45px] '
                            setSelectedOption={(e: { label: string; value: string }) => {
                              setUpdatedBranchInfo((prev) => ({ ...prev, selectedLga: e.label }));
                            }}
                            isLoading={lgaLoading}
                            // value={updatedBranchInfo?.selectedLga}
                            label='Local Government Area'
                            placeholder={updatedBranchInfo?.selectedLga}
                            labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                            options={
                              states &&
                              states
                                ?.find(
                                  (item: any) => item?.name === updatedBranchInfo?.selectedState,
                                )
                                ?.lgas?.map((item: any) => {
                                  return {
                                    label: item,
                                    value: item,
                                  };
                                })
                            }
                            width='100%'
                          />
                          {displayErrorMsg(
                            'Local government cannot be empty',
                            updatedBranchInfo?.selectedLga,
                          )}
                        </div>
                        <div className='w-full sl:w-[48%] text-xs mb-[37px] '>
                          <div className=''>
                            <h4 className='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '>
                              City or Town
                            </h4>
                            <input
                              className='w-full h-[45px] text-[#768396] font-normal text-xs px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                              value={updatedBranchInfo?.cityOrTown ?? ''}
                              placeholder={'Type city or town'}
                              onChange={(e) => {
                                setUpdatedBranchInfo((prev) => ({
                                  ...prev,
                                  cityOrTown: e.target.value.replace(/[0-9]/g, ''),
                                }));
                              }}
                            />
                          </div>
                          {displayErrorMsg(
                            'City or Town cannot be empty',
                            updatedBranchInfo?.cityOrTown ?? '',
                          )}
                        </div>
                      </div>
                      <div className='sl:flex justify-between'>
                        <div className='w-full sl:w-[48%] text-xs mb-[37px] '>
                          <Dropdown
                            className='border rounded-[2px] !h-[45px] '
                            placeholder={updatedBranchInfo?.nearestSterlingState?.value}
                            label='Sterling Bank Location'
                            labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                            options={nearestSterlingStates?.map((state: any) => {
                              return {
                                label: state?.state,
                                value: state?.state,
                                lgas: state?.listOfBranches,
                              };
                            })}
                            width='100%'
                            isLoading={branchLoading}
                            setSelectedOption={(e: {
                              label: string;
                              value: string;
                              lgas: string[];
                            }) => {
                              setUpdatedBranchInfo((prev) => ({
                                ...prev,
                                nearestSterlingState: e,
                              }));
                            }}
                          />
                          {displayErrorMsg(
                            'Sterling bank location cannot be empty',
                            updatedBranchInfo?.nearestSterlingState?.value,
                          )}
                        </div>
                        <div className='w-full sl:w-[48%] text-xs mb-[37px] '>
                          <Dropdown
                            className='border rounded-[2px] !h-[45px] '
                            label='Nearest Sterling Bank Branch'
                            placeholder={updatedBranchInfo?.nearestSterlingBranch}
                            labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                            options={updatedBranchInfo?.nearestSterlingState?.lgas?.map(
                              (item: any) => {
                                return {
                                  label: item?.address,
                                  value: item?.address,
                                };
                              },
                            )}
                            width='100%'
                            placeholderFont='!text-[12px]'
                            isLoading={branchLoading}
                            setSelectedOption={(e: { label: string; value: string }) => {
                              setUpdatedBranchInfo((prev) => ({
                                ...prev,
                                nearestSterlingBranch: e.label,
                              }));
                            }}
                          />
                          {displayErrorMsg(
                            'Sterling bank branch cannot be empty',
                            updatedBranchInfo?.nearestSterlingBranch,
                          )}
                        </div>
                      </div>

                      {
                        <div className='flex justify-center flex-col md:w-full   mx-auto'>
                          <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center'>
                            <Button2
                              // disabled={disabled}
                              type='submit'
                              theme='primary'
                              className='px-3 py-[10px] text-[11px] inline-block rounded-[6px]'
                              size='sm'
                              underline={false}
                              onClick={(e) => {
                                e.preventDefault();
                                setSubmitting(true);
                                if (!disabled) {
                                  const updatedBranches = branches?.map((branch, ind) => {
                                    if (ind === branchIndex) {
                                      return updatedBranchInfo;
                                    } else {
                                      return branch;
                                    }
                                  });
                                  setInLocalStorageLtd({
                                    prop: 'branches-ltd',
                                    value: updatedBranches,
                                  });
                                  setBranches(updatedBranches);
                                  updateBranchesInTable(updatedBranches);
                                  setShowSuccessModal(true);
                                }
                              }}
                            >
                              SAVE ADDRESS
                            </Button2>

                            <Button2
                              type='submit'
                              theme='danger'
                              className='px-3 py-[10px] text-[11px] inline-block rounded-[6px]'
                              size='sm'
                              underline={false}
                              onClick={(e) => {
                                e.preventDefault();
                                setShowModal(false);
                              }}
                            >
                              CANCEL
                            </Button2>
                          </div>
                        </div>
                      }
                    </div>
                    <AddressSavedModal
                      setShowSuccessModal={setShowSuccessModal}
                      showSuccessModal={showSuccessModal}
                      description={`Address was successfully updated`}
                      handleClick={() => {
                        setShowSuccessModal(false);
                        setShowModal(false);
                      }}
                      bottomText={`Close`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default EditAddressModal;
